/**
 * Salonomy brand tokens (FOUNDATION.md). The .dc.html prototypes are the visual source of
 * truth; these seed every surface (console, marketing, mobile) and the API docs theme.
 */
export const colors = {
  ink: '#161D33',
  porcelain: '#F6F7F9',
  cobalt: '#3A55D9',
  cobaltHover: '#2E45BE',
  cobaltLight: '#7B93FF',
  slate: '#5A6175',
  muted: '#9AA3BD',
  border: '#E3E6ED',
  success: '#2E7D54',
  danger: '#B0432F',
} as const;

export const fonts = {
  display: "'Instrument Serif', serif",
  body: "'Instrument Sans', sans-serif",
  mono: "'Spline Sans Mono', monospace",
} as const;

export const radii = { sm: '10px', md: '14px', lg: '20px', pill: '100px' } as const;

export type Colors = typeof colors;
export type Fonts = typeof fonts;
